import React, { useState } from "react";
import { CCAlert, CCButton, CCModal } from "@pymblecitizencoders/cc-ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { EventDoc } from "../../types/event";
import { EventModalPreview } from "./EventModalPreview";
import "./eventManager.css";

interface PermissionCardPreviewProps {
	/** The editor's draft, so unsaved edits are what gets previewed. */
	event: EventDoc;
}

/**
 * "Preview permission card" (an eye): what the permission a parent
 * is asked to give looks like, built from this event's own draft.
 *
 * READ-ONLY AND SAMPLE-ONLY, on purpose. The buttons are disabled rather than
 * absent so the card reads as it will, but nothing here can submit, and the
 * student and parent are invented names, never a real attendee: the event
 * document carries a roll that a preview has no reason to touch.
 *
 * The window draws the event modal a carer opens from the card (see
 * EventModalPreview, which shares its approval rows with ApprovalCardPreview,
 * the card itself).
 *
 * Offered only while permission is ticked (`Approval.Required`), on the
 * Permissions tab.
 */
export const PermissionCardPreview: React.FC<PermissionCardPreviewProps> = ({
	event,
}) => {
	const [open, setOpen] = useState(false);
	const approval = event.Approval;
	if (approval?.Required !== true) return null;

	return (
		<>
			<CCButton
				variant="outline"
				size="sm"
				onClick={() => setOpen(true)}
				aria-label="Preview permission card"
				title="Preview permission card"
			>
				<FontAwesomeIcon icon={faEye} aria-hidden="true" />
			</CCButton>

			<CCModal
				open={open}
				onClose={() => setOpen(false)}
				title="Permission card preview"
				className="em-pcard-modal"
				footer={
					<CCButton variant="outline" onClick={() => setOpen(false)}>
						Close
					</CCButton>
				}
			>
				<CCAlert tone="danger" className="em-pcard-alert">
					This is a preview only.
				</CCAlert>

				<EventModalPreview event={event} />
			</CCModal>
		</>
	);
};
